import { Navbar } from "./Navbar";
import React from "react";

export function NotFound() {
  return (
    <>
      <Navbar />
      <h1 className="text-center font-normal text-4xl mt-32">Page not found</h1>
    </>
  );
}
